import { infiniteQueryOptions, keepPreviousData } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants.ts";
import { PAGINATION, QUERY_CACHE } from "@/constants/constants.ts";
import { getNextPage } from "@/helpers/api/getNextPageParam/helper";

import type { CreateSearchTidLinkedAccountsInfiniteQueryOptions } from "./types";

export function createSearchTidLinkedAccountsInfiniteQueryOptions({
  getTidLinkedAccountsFn,
  accountId,
  typeIds,
  enabled,
}: CreateSearchTidLinkedAccountsInfiniteQueryOptions) {
  return infiniteQueryOptions({
    queryKey: [queries.GET_TID_LINKED_ACCOUNTS, { accountId, typeIds }],
    initialPageParam: PAGINATION.DEFAULT_FIRST_PAGE,
    placeholderData: keepPreviousData,
    queryFn: ({ pageParam }) =>
      getTidLinkedAccountsFn({
        filters: {
          accountId,
          typeIds,
        },
        paging: {
          page: pageParam,
          size: PAGINATION.DEFAULT_PER_PAGE,
        },
      }),
    enabled: enabled,
    getNextPageParam: (lastPage) => getNextPage(lastPage.pagination),
    staleTime: QUERY_CACHE.DEFAULT.STALE_TIME,
    gcTime: QUERY_CACHE.DEFAULT.GC_TIME,
  });
}
